module.exports = __webpack_public_path__ + "img/draggable.0ca703d9.svg";